function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath11773"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 500h500v-500h-500z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath11781"
}, /*#__PURE__*/React.createElement("path", {
  d: "m94.816 397.47h332.35v-146.31h-332.35z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath11885"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 500h500v-500h-500z"
})));

var SvgNotFound404 = function SvgNotFound404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 523.5,
    height: 409.37,
    viewBox: "0 0 523.5 409.37",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 -60.329 610.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.4349,-26.255)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath11773)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath11781)",
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(403.42,347.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-26.539v23.775c0 14.581-10.683 26.512-23.739 26.512h-234.59c-13.056 0-23.739-11.931-23.739-26.512v-36.017c0-14.581 10.683-26.511 23.739-26.511h29.246c0.708-1.506 1.541-2.927 2.486-4.247h-2.698c-13.057 0-23.739-11.93-23.739-26.511s10.682-26.511 23.739-26.511h187.55c13.057 0 23.739 11.93 23.739 26.511 0 6.22-1.948 11.954-5.191 16.489h49.738c13.058 0 23.74 11.93 23.74 26.511s-10.682 26.511-23.74 26.511",
    style: {
      fill: "#ffb22d"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420.68,354.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-29.291c-3.564 0-6.48 2.916-6.48 6.48s2.916 6.48 6.48 6.48h29.291c3.564 0 6.48-2.916 6.48-6.48s-2.916-6.48-6.48-6.48",
    style: {
      fill: "#ffb22d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(438.84,271.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-65.597c-3.563 0-6.479 2.916-6.479 6.48s2.916 6.48 6.479 6.48h65.597c3.564 0 6.48-2.916 6.48-6.48s-2.916-6.48-6.48-6.48",
    style: {
      fill: "#ffb22d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.27,289.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-44.402c-3.564 0-6.48-2.916-6.48-6.48s2.916-6.479 6.48-6.479h44.402c3.564 0 6.48 2.915 6.48 6.479s-2.916 6.48-6.48 6.48",
    style: {
      fill: "#ffb22d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.223,309.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-7.585c-3.564 0-6.48-2.916-6.48-6.48s2.916-6.479 6.48-6.479h7.585c3.563 0 6.479 2.915 6.479 6.479s-2.916 6.48-6.479 6.48",
    style: {
      fill: "#ffb22d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(409.87,375.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.198-2.25-2.071-3.904-4.185-3.693-2.112 0.21-3.665 2.205-3.467 4.455 0.198 2.251 2.071 3.905 4.183 3.694 2.114-0.21 3.666-2.206 3.469-4.456",
    style: {
      fill: "#f9d6b9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.352,314.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.198-2.25-2.071-3.904-4.184-3.693-2.113 0.21-3.666 2.205-3.468 4.456 0.198 2.25 2.071 3.904 4.184 3.693 2.113-0.21 3.666-2.206 3.468-4.456",
    style: {
      fill: "#f9d6b9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.79,422.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.198-2.25-2.071-3.904-4.184-3.693-2.113 0.21-3.666 2.205-3.468 4.455 0.198 2.251 2.071 3.905 4.184 3.694 2.113-0.21 3.666-2.206 3.468-4.456",
    style: {
      fill: "#f9d6b9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(436.57,352.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.071-1.414-1.205-2.498-2.532-2.422-1.328 0.076-2.346 1.283-2.275 2.697 0.072 1.414 1.205 2.498 2.533 2.423 1.327-0.076 2.345-1.284 2.274-2.698",
    style: {
      fill: "#f9d6b9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(443.01,356.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.045-0.884-0.754-1.562-1.583-1.514-0.83 0.047-1.467 0.802-1.422 1.686s0.753 1.561 1.583 1.514 1.466-0.802 1.422-1.686",
    style: {
      fill: "#f9d6b9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399.7,263.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.071-1.414-1.205-2.498-2.532-2.422-1.328 0.076-2.346 1.283-2.275 2.697 0.072 1.414 1.205 2.498 2.533 2.423 1.327-0.076 2.345-1.284 2.274-2.698",
    style: {
      fill: "#f9d6b9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385.11,266.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.045-0.884-0.753-1.562-1.583-1.514-0.83 0.047-1.466 0.802-1.422 1.686 0.045 0.884 0.754 1.561 1.583 1.514 0.83-0.048 1.467-0.803 1.422-1.686",
    style: {
      fill: "#f9d6b9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.42,298.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.071-1.414-1.205-2.499-2.532-2.422-1.328 0.075-2.346 1.283-2.275 2.697 0.072 1.413 1.205 2.498 2.533 2.422 1.327-0.076 2.346-1.283 2.274-2.697",
    style: {
      fill: "#f9d6b9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.824,301.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.045-0.884-0.753-1.562-1.583-1.514-0.83 0.047-1.466 0.802-1.422 1.686 0.045 0.884 0.754 1.561 1.583 1.514 0.83-0.047 1.466-0.802 1.422-1.686",
    style: {
      fill: "#f9d6b9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.23,406.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.071-1.414-1.206-2.498-2.533-2.422s-2.345 1.283-2.274 2.697 1.205 2.498 2.533 2.422c1.327-0.075 2.345-1.283 2.274-2.697",
    style: {
      fill: "#f9d6b9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.64,409.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.045-0.884-0.753-1.562-1.583-1.514-0.83 0.047-1.466 0.802-1.422 1.686 0.045 0.884 0.754 1.561 1.583 1.514 0.83-0.047 1.466-0.802 1.422-1.686",
    style: {
      fill: "#f9d6b9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317.51,232.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-4.558-29.685-8.252-66.302-8.252s-66.301 3.694-66.301 8.252c0 4.557 29.684 8.251 66.301 8.251s66.302-3.694 66.302-8.251",
    style: {
      fill: "#e7e2e4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m261.23 241.62h-25.16v19.774h25.16z",
    style: {
      fill: "#b7b4b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.23 255.04h-25.16v9.887h25.16z",
    style: {
      fill: "#979797"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.2,230.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-91.099c-2.411 0-4.384 1.974-4.384 4.385v3.297c0 2.411 1.973 4.384 4.384 4.384h91.099c2.412 0 4.386-1.973 4.386-4.384v-3.297c0-2.411-1.974-4.385-4.386-4.385",
    style: {
      fill: "#979797"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(318.74,352.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-51.599l-11.809-11.774 9.499-8.472-23.362-29.524 8.711 26.957-11.793 8.472 6.676 7.553-6.676 6.788h-57.117c-1.697 0-3.086-1.389-3.086-3.086v-84.67c0-1.698 1.389-3.086 3.086-3.086h137.47c1.697 0 3.086 1.388 3.086 3.086v84.67c0 1.697-1.389 3.086-3.086 3.086",
    style: {
      fill: "#554a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(321.82,268.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-143.64v-4.766c0-1.271 1.03-2.301 2.301-2.301h139.04c1.271 0 2.301 1.03 2.301 2.301z",
    style: {
      fill: "#b7b4b6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(313.55,345.45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-53.222l-5.002-4.986 9.499-8.472-23.362-29.524 8.712 26.956-11.793 8.472 6.675 7.554h-58.609c-1.371 0-2.493-1.122-2.493-2.493v-65.066c0-1.371 1.122-2.493 2.493-2.493h127.1c1.372 0 2.493 1.122 2.493 2.493v65.066c0 1.371-1.121 2.493-2.493 2.493",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.78,321.83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-16.557-32.986c8.321-1.859 17.19 2.027 21.161 10.009 4.012 7.983 1.858 17.402-4.604 22.977",
    style: {
      fill: "#ffa84a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.38,315.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.97-7.982-1.816-17.401 4.646-22.977l16.557 32.987c-8.321 1.858-17.19-2.028-21.203-10.01",
    style: {
      fill: "#ffa84a"
    }
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "scale(1,-1)",
    x: 140.25819,
    y: -151.12,
    style: {
      fill: "#554a64",
      fontFamily: "Barlow",
      fontSize: "17.146px"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 140.25819,
    y: -151.12,
    style: {
      fontFamily: "Roboto"
    }
  }, "P\xC1GINA N\xC3O ENCONTRADA")), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3c3584"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath11885)",
    style: {
      fill: "#3c3584"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.1,351.22)",
    style: {
      fill: "#3c3584"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c4.324 4.143 0.587 12.204-5.872 12.666-4.526 0.323-10.247-2.024-12.915 1.197-1.734 2.095-0.506 4.995-0.996 7.532-2.018 10.447-19.85 8.185-27.121 9.046-12.477 1.476-25.242 12.088-25.325 25.883-0.045 7.699 4.111 14.934 9.626 20.215 26.318 25.199 70.437 32.486 105 29.541 21.92-1.868 57.097-7.346 61.131-34.794 1.134-7.723-1.751-15.633-6.326-21.913-19.729-27.078-58.533-23.424-87.367-20.985-3.042 0.258-6.228 0.497-9.032-0.522-2.805-1.019-5.024-3.739-4.102-6.28 5.959-0.847 10.995-5.437 11.687-10.651s-3.02-10.587-8.617-12.468z",
    style: {
      fill: "#3c3584"
    }
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.99843 -.05595 -.05595 -.99843 201.65 403.86)",
    style: {
      fill: "#ffffff",
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "Roboto",
      fontWeight: "bold"
    }
  }, "O")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.99997 -.0075045 -.0075045 -.99997 218.29 402.94)",
    style: {
      fill: "#ffffff",
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, "O")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.99919 .040336 .040336 -.99919 234.96 402.83)",
    style: {
      fill: "#ffffff",
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, "O")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.99583 .091186 .091186 -.99583 251.64 403.51)",
    style: {
      fill: "#ffffff",
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, "O")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9891 .14725 .14725 -.9891 268.33 405.05)",
    style: {
      fill: "#ffffff",
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, "O")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.97824 .20747 .20747 -.97824 284.97 407.57)",
    style: {
      fill: "#ffffff",
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, "P")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.96219 .27239 .27239 -.96219 300.06 410.78)",
    style: {
      fill: "#ffffff",
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, "A")), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 35.782452,
    style: {
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.94505 .32692 .32692 -.94505 0 0)",
    x: 440.99374,
    y: -289.23611,
    style: {
      fill: "#ffffff",
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 440.99374,
    y: -289.23611,
    style: {
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, ".")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.93056 .36615 .36615 -.93056 0 0)",
    x: 460.13876,
    y: -270.72244,
    style: {
      fill: "#ffffff",
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 460.13876,
    y: -270.72244,
    style: {
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, ".")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.91303 .40789 .40789 -.91303 0 0)",
    x: 480.33563,
    y: -250.10448,
    style: {
      fill: "#ffffff",
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 480.33563,
    y: -250.10448,
    style: {
      fontFamily: "Roboto",
      fontSize: "28.61px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 500
    }
  }, ".")), /*#__PURE__*/React.createElement("text", {
    transform: "scale(1,-1)",
    x: 148.37086,
    y: -174.9989,
    style: {
      fill: "#3c3584",
      fontFamily: "'Franklin Gothic Demi Cond'",
      fontSize: "45.784px",
      fontStretch: "condensed"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 148.37086,
    y: -174.9989,
    style: {
      fontFamily: "Roboto",
      fontStretch: "normal",
      fontWeight: "bold"
    }
  }, "ERRO 404")), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-7.4349,-26.255)",
    d: "m250.18 329.43-8.7116-26.957 18.759 24.201z",
    style: {
      fillOpacity: 0.74118,
      fillRule: "evenodd",
      fill: "#ffc663",
      strokeOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#000000",
      fontFamily: "sans-serif",
      fontSize: "30.001px",
      lineHeight: 1.25,
      shapeInside: "url(#rect237)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotFound404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NotFound404.07522da1.svg";
export { ForwardRef as ReactComponent };